//copied from VPC
import * as React from 'react';
import { ISanitizer, sanitize } from '../../../../common/utils/Sanitize';
import { TextileHelper } from '../../../../common/utils/TextileHelper';
import { DetailsTooltipStyles } from '../DetailsTooltipStyles';
import { ContentDescriptionClassNames } from '../TooltipHelper';

export interface MarkupFieldProps {
  label?: string;
  markup?: string;
  testId?: string;
  extraClasses?: string[];
}

export function MarkupField(props: MarkupFieldProps) {
  const sanitizeFn = sanitize;
  const htmlContent = getSanitizedHtmlFromMarkup(props.markup || '', sanitizeFn);

  if (!props.markup || !htmlContent) {
    return null;
  }

  // Open anchor tag links in a new tab by default
  const $tempElement = document.createElement('DIV');
  $tempElement.innerHTML = htmlContent.__html;
  $tempElement.querySelectorAll('a').forEach((a) => {
    if (!a.getAttribute('target')) {
      a.setAttribute('target', '_blank');
    }
  });
  htmlContent.__html = $tempElement.innerHTML;

  const classes = [DetailsTooltipStyles.MetadataSection].concat(props.extraClasses || []).join(' ');

  return (
    <div className={classes} data-tb-test-id={props.testId}>
      {props.label && <div className={DetailsTooltipStyles.MultiLineTitle}>{props.label}</div>}

      <div className={ContentDescriptionClassNames} dangerouslySetInnerHTML={htmlContent} />
    </div>
  );
}

function getSanitizedHtmlFromMarkup(markup: string, sanitizeFn: ISanitizer): { __html: string } {
  return { __html: TextileHelper.getSanitizedHtmlFromTextile(markup, sanitizeFn) || '' };
}
